import React from 'react'

import Card from 'lemon-campaign-ui/lib/molecules/Card'

export default ({ component, recursive, defaults }) => {
  return (
    <Card {...defaults} borderRadius={component.content.borderRadius}>
      {recursive(component.components)}
    </Card>
  )
}
